module.exports = __webpack_public_path__ + "static/media/frog.6f98c38d.svg";